/**
 * Aws cognito configurations
 */
const authConfig = {
  Auth: {
    // Amazon cognito identity pool id
    identityPoolId: process.env.REACT_APP_AUTH_IDENTITY_POOL_ID,
    // Amazon cognito region
    region: process.env.REACT_APP_AUTH_REGION,
    // Amazon cognito user pool id
    userPoolId: process.env.REACT_APP_AUTH_USER_POOL_ID,
    // Amazon cognito web client id (26 char alphanumeric string)
    userPoolWebClientId: process.env.REACT_APP_AUTH_USER_POOL_WEB_CLIENT_ID,
    // authenticationFlowType: 'REFRESH_TOKEN_AUTH'
  },
  // Hosted UI Configuration
  oauth: {
    domain: process.env.REACT_APP_AUTH_DOMAIN,
    scope: [
      "phone",
      "email",
      "profile",
      "openid",
      "aws.cognito.signin.user.admin",
    ],
    redirectSignIn: `${process.env.REACT_APP_PORTAL_DOMAIN}`,
    redirectSignOut:
      `https://${process.env.REACT_APP_AUTH_DOMAIN}/login?client_id=1cnmqv3lbpnlbf8tnrk42n7ovb&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=${process.env.REACT_APP_PORTAL_DOMAIN}`,
    responseType: "token",
  },
};

export const authConfigs = authConfig;
